import React, { createContext, FC, useContext, useState } from "react";

export interface LayersSearchContextType {
  taskId?: string;
  setTaskId?: (taskId?: string) => void;
  searchFilter?: string;
  setSearchFilter?: (searchFilter?: string) => void;
}

export const LayersSearchContext = createContext<LayersSearchContextType>({});

export const LayersSearchProvider: FC = ({ children }) => {
  const [taskId, setTaskId] = useState<string>();
  const [searchFilter, setSearchFilter] = useState<string>();

  return (
    <LayersSearchContext.Provider
      value={{
        taskId,
        setTaskId,
        searchFilter,
        setSearchFilter,
      }}
    >
      {children}
    </LayersSearchContext.Provider>
  );
};

export const useLayersSearchContext = () => {
  return useContext(LayersSearchContext);
};
